<template>
	<div class="load-indicator__wrapper">
		<div class="load-indicator" :class="[{ 'state-visible': loadingResults === true }, { 'load-indicator-transition': useTransition === true }]">
			<div class="load-indicator__indicator"></div>
			<span class="load-indicator__text">Loading</span>
		</div>
		<div :class="[`load-indicator-cover`, { 'load-indicator-cover-transition': useTransition === true }, { 'state-visible': loadingResults === true }]"></div>

	</div>
</template>
\
<script lang="ts">
export default {
	name: "LoadIndicator",
	props: {
		loadingResults: {
			type: Boolean,
			default: false
		},
		useTransition: {
			type: Boolean,
			default: false
		},
		opacityAmount: {
			type: String,
			default: '1'
		}
	},
	computed: {

	}
};
</script>
